import { render, staticRenderFns } from "./createmessagesendgroup.vue?vue&type=template&id=f0776adc&"
import script from "./createmessagesendgroup.vue?vue&type=script&lang=ts&"
export * from "./createmessagesendgroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createmessagesendgroup.vue"
export default component.exports